import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ScaleService } from 'src/app/service/scale.service';
import { Subscription } from 'rxjs';
import { CanvasStateService } from 'src/app/service/canvas-state.service';

@Component({
  selector: 'app-control-menu',
  templateUrl: './control-menu.component.html',
  styleUrls: ['./control-menu.component.less']
})
export class ControlMenuComponent implements OnInit {

  subscription: Subscription;
  
  @ViewChild('mmcScaleBar') canvasRef: ElementRef;
  @ViewChild('mmcScaleBarContainer') canvasWrapper: ElementRef;
  ctx: CanvasRenderingContext2D;

  constructor(
    public scaleService: ScaleService,
    private canvasState: CanvasStateService
    
    ) { }

    drag:boolean=false;
    dragImg:boolean=false;
    
  ngOnInit() {
    this.ctx=this.canvasRef.nativeElement.getContext('2d'); 
    this.drawScaleBar();

    this.subscription = this.scaleService.scale$.subscribe(data => {
      this.drawScaleBar();
    });
    
    this.subscription = this.canvasState.canvasState$.subscribe(data => {
      // console.log(data)
      if(data.staticName=='drag')
        this.drag=data.active;
      else
        this.drag=false;
    });
  }

  drawScaleBar(){
    let processedSizes=this.scaleService.getProcessedSizes();

    let width=this.canvasWrapper.nativeElement.offsetWidth;
    let height=this.canvasWrapper.nativeElement.offsetHeight;
    this.canvasRef.nativeElement.setAttribute('width',width);
    this.canvasRef.nativeElement.setAttribute('height',height);

    this.ctx.clearRect(0,0,width,height);
    this.ctx.fillStyle='#d10015';
    this.ctx.fillRect(0,2,processedSizes.pixels/2,12)
    this.ctx.fill();
    
    this.ctx.fillStyle='#8b8b8b';
    this.ctx.fillRect(processedSizes.pixels/2,2,processedSizes.pixels/2,12)
    this.ctx.fill();

    this.ctx.fillStyle='#8b8b8b';
    this.ctx.fillRect(0,15,2,6)
    this.ctx.fill();

    this.ctx.fillStyle='#8b8b8b';
    this.ctx.fillRect(processedSizes.pixels/2-1,15,2,6)
    this.ctx.fill();

    this.ctx.fillStyle='#8b8b8b';
    this.ctx.fillRect(processedSizes.pixels-2,15,2,6)
    this.ctx.fill();

    this.ctx.font = "14px Arial";
    this.ctx.fillStyle='black';
    let txtLen = this.ctx.measureText(processedSizes.meters+' m').width;
    this.ctx.fillText(processedSizes.meters+' m', processedSizes.pixels/2-txtLen/2,40);
  }

  zoomIn(){
    this.scaleService.changeScale('+');
    
  }

  zoomOut(){
    this.scaleService.changeScale('-');
  }

  zoomReset(){    
    this.scaleService.changeScale('0');
  }
  zoomFit(){
    this.scaleService.fitScale();
  }

  toggleDrag(){    
    this.drag=!this.drag;
    if(this.drag)
      this.dragImg=false;
    this.canvasState.setState('drag',this.drag);
    // this.scaleService.changeScale('0');
  }

  toggleDragImg(){    
    this.dragImg=!this.dragImg;
    if(this.dragImg)
      this.drag=false;
    this.canvasState.setState('dragImg',this.dragImg);
    // this.scaleService.changeScale('0');
  }

}
